
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSApprovalReturnGrid extends Serenity.EntityGrid<POSApprovalReturnRow, any> {
        protected getColumnsKey() { return 'Retail.POSApprovalReturn'; }
        protected getDialogType() { return POSApprovalReturnDialog; }
        protected getIdProperty() { return POSApprovalReturnRow.idProperty; }
        protected getInsertPermission() { return POSApprovalReturnRow.insertPermission; }
        protected getLocalTextPrefix() { return POSApprovalReturnRow.localTextPrefix; }
        protected getService() { return POSApprovalReturnService.baseUrl; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container);  
            this.slickGrid.setOptions({ rowHeight: 30 });
        }

        protected addButtonClick() {
            
            let now = new Date();

            var voucherNo = FormatHelper.GetVoucherNo(101);
            var userDefinition = Q.Authorization.userDefinition;
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[92].AutoPosting;
            this.editItem(<POSApprovalReturnRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                TransDate: now.toDateString(),
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                EmployeeId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                VoucherTypeId: 101,
                UserId: userDefinition.UserId,
                AutoPosting: autoposting
                       
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        //protected getQuickFilters() {
        //    var filters = super.getQuickFilters();

        //    filters.push({
        //        type: Serenity.LookupEditor,
        //        options: {
        //            lookupKey: POSApprovalReturnRow.lookupKey
        //        },
        //        field: 'TransId',
        //        title: 'Contains Transaction in Details',
        //        handler: w => {
        //            (this.view.params as TransactionListRequest).TransId = Q.toId(w.value);
        //        },
        //        cssClass: 'hidden-xs'
        //    });

        //    return filters;
        //}
    }
}